import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text);
  }
}
